type Properties = {
    onClick: () => void;
};

const FavoriteListItemViewButton = (props: Properties) => {
    return (
        <button className="favorite-button favorite-button-add" onClick={props.onClick}>Ansehen</button>
    );
};
export default FavoriteListItemViewButton;